import { SuccessAnimation } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { IOrganizationPhoneNumberEditingState, organizationsUiStateStore, StoreContext } from '../../store'
import { AppModal } from '../general/AppModal'
import { ContentSection } from '../layout'
import { ResponsiveBody } from '../typography/ResponsiveBody'

const OrganizationPhoneNumberSuccessComponent: React.FC = () => {
  const { t } = useTranslation()
  const { editOrganizationPhoneNumberStore } = useContext(StoreContext)
  const { editingState } = editOrganizationPhoneNumberStore

  const successMessageTimer: any = null

  const resetAndExit = useCallback(() => {
    organizationsUiStateStore.reset()
    editOrganizationPhoneNumberStore.reset()
  }, [editOrganizationPhoneNumberStore])

  const onCloseModal = useCallback(() => {
    if (successMessageTimer) {
      clearTimeout(successMessageTimer)
    }
    if (editingState == IOrganizationPhoneNumberEditingState.Success) {
      resetAndExit()
    } else {
      editOrganizationPhoneNumberStore.setEditingState(IOrganizationPhoneNumberEditingState.NotEditing)
    }
  }, [editOrganizationPhoneNumberStore, editingState, resetAndExit, successMessageTimer])

  return (
    <AppModal id="organization_phone_success_modal" isOpen onClose={onCloseModal}>
      <ContentSection top={false}>
        <StyledVerticalContainer>
          <SuccessAnimation width={'130px'} height={'130px'} />
          <ResponsiveBody> {t(`myOrgsView.editPhoneNumber.success`)}</ResponsiveBody>
        </StyledVerticalContainer>
      </ContentSection>
    </AppModal>
  )
}

export const OrganizationPhoneNumberSuccess = observer(OrganizationPhoneNumberSuccessComponent)

const StyledVerticalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
